import React from 'react'
import './Button.css'

const Button = ({ text, onClick, overrideStyles = false, stylesFromParent, id, disabled }) => {
    var cssClass = disabled ? "mainButtonDisabled" : (overrideStyles ? stylesFromParent : "mainButton")
    return (
        <button
            type='button'
            className={cssClass}
            onClick={onClick}
            id={id}
            disabled={disabled}
        >
            {text}
        </button>
    )
}

export default Button